import { I18NextService } from 'angular-i18next';

export function getTableHeaders(i18: I18NextService, isProratedColumnShown = false) {
  const headers = [
    {
      name: i18.t('shared:licenses.renewalTable.headers.licenseType', { format: 'title' }),
      gridColSize: '10fr',
      gridColMin: '100px'
    },
    {
      name: i18.t('shared:licenses.renewalTable.headers.unitPrice', { format: 'title' }),
      gridColSize: '3fr',
      gridColMin: '80px',
      class: '-end',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('shared:licenses.renewalTable.headers.discount', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: false
    },
    {
      name: i18.t('shared:licenses.renewalTable.headers.unitTotalPrice', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    },
    {
      name: i18.t('shared:licenses.renewalTable.headers.quantity', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-start',
      overflow: true
    },
    {
      name: i18.t('shared:licenses.renewalTable.headers.lineItemPrice', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    }
  ];

  if (isProratedColumnShown) {
    const columnNumber = 2;
    headers.splice(columnNumber, 0, {
      name: i18.t('shared:licenses.renewalTable.headers.unitProratedPrice', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '160px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    });
  }

  return headers;
}
